import { connect } from 'react-redux';
import CurrentConnection from '../../components/checkout/CurrentConnection/CurrentConnection';

// TODO this is the same in ConnectionDate, ModemDelivery and CurrentConnection
// Refactor this into a common component
const mapStateToProps = (state, ownProps) => {
  if (state.form.checkout.values) {
    const currentBroadbandProvider = state.form.checkout.values.currentBroadbandProvider;
    const landline = state.form.checkout.values.landline;
    if (landline && landline === 'yes') {
      return { showExistingLandlineProvider: true, currentBroadbandProvider, props: ownProps };
    }
    return { currentBroadbandProvider, props: ownProps };
  }

  return { props: ownProps };
};

const CurrentConnectionContainer = connect(mapStateToProps)(CurrentConnection);

export default CurrentConnectionContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/CurrentConnectionContainer.js
 **/